import { Component, EventEmitter, Output } from "@angular/core";
import {
  faCalendarWeek,
  faCalendarAlt,
} from "@fortawesome/pro-light-svg-icons";

@Component({
  selector: "app-create-new-comps-base",
  templateUrl: "./create-new-comps-base.component.html",
  styleUrls: ["./create-new-comps-base.component.scss"],
})
export class CreateNewCompsBaseComponent {
  faCalendarWeek = faCalendarWeek;
  faCalendarAlt = faCalendarAlt;
  @Output() setContext: EventEmitter<string> = new EventEmitter();

  onClick(type: string) {
    switch (type) {
      case "Comparison":
        this.setContext.emit("Comparison");
        break;
      default:
        this.setContext.emit("Trend");
        break;
    }
  }
}
